export default "__VITE_ASSET__Batip$UT__"